import React from 'react'

import { node, string } from 'prop-types'

function CheckoutInfoCard({ title, children }) {
  return (
    <div className="checkout-info-card">
      <p className="checkout-info-card__title cgt-body-base-semibold">{title}</p>
      <div className="checkout-info-card__body cgt-body-base">{children}</div>
    </div>
  )
}

CheckoutInfoCard.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
}

export default CheckoutInfoCard
